(() => {
  const initHero = (root) => {
    if (!root || root.dataset.prReady === 'true') return;
    root.dataset.prReady = 'true';
    const buttons = root.querySelectorAll('[data-pr-mode]');
    const headline = root.querySelector('[data-pr-headline]');
    const copy = root.querySelector('[data-pr-copy]');
    const secondary = root.querySelector('[data-pr-secondary]');

    const applyMode = (mode) => {
      const source = root.querySelector(`[data-pr-mode="${mode}"]`);
      if (!source) return;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === source)));
      if (headline) headline.textContent = source.dataset.headline || '';
      if (copy) copy.textContent = source.dataset.copy || '';
      if (secondary) {
        secondary.textContent = source.dataset.ctaLabel || '';
        secondary.href = source.dataset.ctaUrl || '#';
      }
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyMode(button.dataset.prMode)));
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-pr-hero]').forEach(initHero);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
